import type { ModuleDefinition } from "../types";
import "./messages.nav";
import { NOTIFICATIONS_MANAGE } from "./permissions";

const screens = () => import("./screens");

/** The notification engine: the bell's inbox and settings (every staff member, for themselves), the outbox and
 * the message templates (notifications.manage). */
export const notificationsModule: ModuleDefinition = {
  id: "notifications",
  labelKey: "module.notifications",
  nav: [
    { id: "notifications-outbox", labelKey: "notifications.nav.outbox", to: "/notifications/outbox", icon: "bell", permission: NOTIFICATIONS_MANAGE },
    { id: "notifications-templates", labelKey: "notifications.nav.templates", to: "/notifications/templates", icon: "edit", permission: NOTIFICATIONS_MANAGE },
  ],
  routes: [
    { path: "notifications", load: async () => ({ default: (await screens()).InboxPage }) },
    { path: "notifications/settings", load: async () => ({ default: (await screens()).SettingsPage }) },
    { path: "notifications/outbox", permission: NOTIFICATIONS_MANAGE, load: async () => ({ default: (await screens()).OutboxPage }) },
    { path: "notifications/templates", permission: NOTIFICATIONS_MANAGE, load: async () => ({ default: (await screens()).TemplatesPage }) },
  ],
};
